import React, { PureComponent } from 'react';
import PropType from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import amplitude from 'amplitude-js/amplitude';
import { PAGE_VISIT_FRONTPAGE /* , CLICK_FORUM_LINK */ } from '../../constants/amplitudeEvents';
import RecentWorkouts from './components/RecentWorkouts';
// import ExternalLink from '../../components/Link/ExternalLink';

export class SuuntoHomeComponent extends PureComponent {
  static propTypes = {
    t: PropType.func,
  }

  static defaultProps = {
    t: (str) => str,
  }

  componentDidMount() {
    amplitude.getInstance().logEvent(PAGE_VISIT_FRONTPAGE, {
      Referrer: document.referrer,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <section className="hero is-app-hero is-relative home-hero-image">
          <div className="container is-relative is-suunto app-hero-content is-fullhd">
            <div className="columns">
              <div className="column is-7">
                <h1 className="title is-2 is-size-3-mobile is-size-1-fullhd is-spaced has-text-white is-uppercase">{t('TXT_GET_TO_KNOW_SUUNTOAPP_BETA')}</h1>
                <h2 className="subtitle is-3 is-size-4-mobile is-size-2-fullhd has-text-white">
                  {t('TXT_JOIN_SUUNTOAPP_BETA')}
                </h2>
                { /* <h2 className="subtitle is-3 is-size-4-mobile is-size-2-fullhd has-text-white">
                {t('TXT_BEST_THINGS_TOGETHER')}
              </h2> */ }
              </div>
              <div className="column is-4 is-offset-1 is-relative is-hidden-touch">
                <img src="/images/frontpage/suunto/iphone_hero_trail_running@2x.png" alt="app example" className="is-absolute-desktop is-app-hero-example-phone" />
              </div>
            </div>
          </div>
        </section>
        <section className="is-relative is-app-hero-download">
          <div className="container is-relative is-suunto is-fullhd">
            <div className="columns">
              <div className="column is-7 is-12-touch">
                <div className="columns is-mobile is-multiline is-centered">
                  <div className="column is-12">
                    <h2 className="subtitle is-3 is-size-4-mobile is-size-2-fullhd has-text-centered"><b>{t('TXT_FIND_OUT_HOW_TO_JOIN')}</b></h2>
                  </div>
                  <div className="column is-narrow">
                    <Link to="/getstarted" className="button is-primary is-medium is-uppercase">{t('TXT_GET_STARTED_NOW')}</Link>
                    {/* <ExternalLink amplitudeCTA="CallToJoin" amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="FrontPage" href="https://forum.suunto.com" className="button is-primary is-medium is-uppercase" text={t('TXT_GET_STARTED_NOW')} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <RecentWorkouts />
        <div className="has-large-gap is-relative">
          { /* <img className="is-frontpage-bottom-hero-image" src="/images/frontpage/suunto/bottom_background@2x.jpg" alt="bottom hero" />
        <h2 className="subtitle is-2 is-size-3-mobile is-frontpage-bottom-hero-title has-text-white is-absolute is-white has-text-centered">{t('TXT_BE_PART_OF')}</h2>
         <ExternalLink amplitudeCTA="CallToJoin" amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="FrontPage" href="https://www.surveygizmo.eu/s3/90052074/Suunto-App-Registration-survey" className="button is-large is-absolute is-frontpage-bottom-hero-button" text={t('TXT_GET_ACCESS_TO_BETA').toUpperCase()} /> */ }
        </div>
      </div>
    );
  }
}
export default translate()(SuuntoHomeComponent);
